import { ChevronRight } from 'lucide-react'
import { cn } from '@/ui/utils/style'

const STEP_COLORS = ['font-medium text-[#A1FCE7]', 'font-medium text-[#FCE572]', 'font-medium text-[#9DDEF7]'] as const

const FINAL_STEP_STYLE = {
  background: 'linear-gradient(90deg, #FCE572 0%, #A1FCE7 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
} as const

interface StepJourneyProps {
  steps: string[]
  className?: string
}

export function StepJourney({ steps, className }: StepJourneyProps) {
  if (steps.length === 0) return null

  return (
    <div className={cn('hidden items-center gap-2 text-sm sm:flex', className)}>
      {steps.map((step, i) => {
        const isLast = i === steps.length - 1
        return (
          <span key={step} className="contents">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-white/20" />}
            {isLast ? (
              <span className="font-semibold" style={FINAL_STEP_STYLE}>
                {step}
              </span>
            ) : (
              <span className={STEP_COLORS[i % STEP_COLORS.length]}>{step}</span>
            )}
          </span>
        )
      })}
    </div>
  )
}
